import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const siteUrl = 'https://www.centrulprogres.com';

const pages: Record<string, { title: string; description: string }> = {
  '/': {
    title: 'Centrul Progres București | Meditații și limbi străine',
    description: 'Cursuri de limbi străine și meditații la română și matematică în București, Sector 2. Grupe restrânse, profesori dedicați și opțiuni pentru clasele I-XII.'
  },
  '/packages': {
    title: 'Cursuri și prețuri | Centrul Progres București',
    description: 'Prețuri și pachete pentru limbi străine, limba română și matematică la Centrul Progres, pentru elevi din clasele I-XII.'
  },
  '/teachers': {
    title: 'Profesorii Centrului Progres | București',
    description: 'Cunoaște profesorii Centrului Progres pentru limba română, matematică și limbi străine, cu pregătire și experiență adaptate elevilor.'
  },
  '/contact': {
    title: 'Contact și locație | Centrul Progres București',
    description: 'Contactează Centrul Progres la 0726 423 784 sau 0723 696 188. Ne găsești pe Șoseaua Colentina nr. 16, Sector 2, București.'
  },
  '/colaborari': {
    title: 'Cum colaborăm | Centrul Progres',
    description: 'Află detaliile despre plată, absențe, recuperarea ședințelor și regulile de colaborare cu Centrul Progres.'
  },
  '/terms-conditions': {
    title: 'Termeni și condiții | Centrul Progres',
    description: 'Termenii, condițiile și politica de confidențialitate pentru serviciile și website-ul Centrului Progres.'
  }
};

const setMeta = (selector: string, attribute: 'name' | 'property', key: string, content: string) => {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.content = content;
};

const Seo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = pages[pathname] ?? pages['/'];
    const canonicalUrl = `${siteUrl}${pathname === '/' ? '' : pathname}`;

    document.documentElement.lang = 'ro';
    document.title = page.title;
    setMeta('meta[name="description"]', 'name', 'description', page.description);
    setMeta('meta[property="og:title"]', 'property', 'og:title', page.title);
    setMeta('meta[property="og:description"]', 'property', 'og:description', page.description);
    setMeta('meta[property="og:url"]', 'property', 'og:url', canonicalUrl);
    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', page.title);
    setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', page.description);

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default Seo;
